import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { COLORS } from "../../../constants";
import ListViewCommon from "./ListViewCommon";
import { faMap } from "@fortawesome/free-solid-svg-icons";
import CustomFab from "../../../components/CustomFAB/CustomFAB";
import { useNavigation } from "@react-navigation/native"; // Import navigation hook
import { useBottomTabBarHeight } from "@react-navigation/bottom-tabs";
import { logAnalyticsEvent } from "../../../utils/firebase";
/**
 * ListView component for Parking, Bathrooms, Attractions renders a common list view for web.
 * It passes the FontAwesomeIcon component to ListViewCommon as a prop for rendering icons.
 *
 * @param {Array} data - The data to be displayed in the list.
 * @returns {JSX.Element} The rendered ListView component for the web.
 */
const ListView = ({ data, type }) => {
  logAnalyticsEvent("screen_view", { name: `VBGo-${type}ListView` });

  const navigation = useNavigation(); // Access navigation
  const bottomTabBarHeight = useBottomTabBarHeight();
  const pageType = type || (data?.length > 0 ? data[0]?.type : null);

  const handleFabClick = () => {
    if (pageType === "parking") {
      navigation.navigate("ParkingMapView");
    } else if (pageType === "bathroom") {
      navigation.navigate("BathroomMapView");
    } else if (pageType === "attraction") {
      navigation.navigate("AttractionsMapView");
    }
  };

  return (
    <div
      style={{
        ...styles.container,
        height: `calc(100vh - ${bottomTabBarHeight}px)`, // Adjust height to account for the bottom tab bar
      }}
    >
      {/* Renders the common ListView logic and passes FontAwesomeIcon for icon rendering */}
      <ListViewCommon data={data} type={pageType} FontAwesomeIcon={FontAwesomeIcon} iconSize={"1x"} />
      {/* Floating Action Button */}
      {(pageType === "parking" || pageType === "bathroom" || pageType === "attraction") && (
        <CustomFab
          onFabClick={handleFabClick} // Trigger navigation
          FontAwesomeIcon={FontAwesomeIcon}
          icon={faMap}
          size={"lg"}
          color={COLORS.textLight}
          bottomOffset={16}
          rightOffset={16}
          accessibilityLabel={`${pageType} Map`}
        />
      )}
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: COLORS.backgroundColor,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    position: "relative",
  },
};

export default ListView;
